/* eslint no-eval: 0 */

import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import React, { Fragment, useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { Datagrid, FunctionField, List, ShowButton, TextField } from 'react-admin';
import ResetViewsButton from '../bulk/ResetViewsButton';
import FormDialogPayement from '../dialog/FormDialogPayement.js';
import FiltreReception from '../filtres/FiltreReception';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { has_role } from '../references';
import rowStyleReception from '../styles/rowStyleReception';

 const  ListReception=(props)=>{

    const [fullname, setFullname] = useState('');
    const [reste_a_payer, setReste_a_payer] = useState();
    //const [roles, setRole] = useState();
    const {permissions}=props;

  

    useEffect(() => {
        setFullname(localStorage.getItem('fullname'));
        //setRole(localStorage.getItem('roles'));
    }, []);



    const selectableAerien=(recep_user_id,camp_type)=>{
        return  (recep_user_id!=null && recep_user_id===0 && !has_role(permissions,'ROLE_MANAGER')) &&
        ((camp_type==='AERIEN' || camp_type==='MARITIME') && !has_role(permissions,'ROLE_AG_EXP_AERIEN_FR') ||
         (camp_type==='AERIEN_DE_CNKRY' && has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')) );
     }

 return(
        <List {...props} 
                bulkActionButtons={<PostBulkActionButtons {...props} reste_a_payer={reste_a_payer} roles={permissions}/>}
               // actions={<ListActions/>}
                filters={<FiltreReception  {...props} type={has_role(permissions,'ROLE_AG_EXP_AERIEN_FR') ? 'AERIEN_DE_CNKRY':'AERIEN'} />} 
                filterDefaultValues={has_role(permissions,'ROLE_AG_EXP_AERIEN_FR') ? {'camp_type':'AERIEN_DE_CNKRY'}: {'camp_type':'AERIEN'}} 
                pagination={<PostPagination {...props} />}
                sort={{ field: 'id', order: 'ASC' }}
                title={'Reception - '+fullname}
                empty={false}
            >
                
            <Datagrid rowStyle={rowStyleReception} isRowSelectable={record =>selectableAerien(record.recep_user_id,record.camp_type) } >
                <TextField source="numCodeEtiq" label="Code" style={{ color: 'purple'  }} sortBy="numCodeEtiq"/>
                <TextField source="camp_type" label="Type" />
                <TextField source="fullname_exp" label="Expéditaire" sortBy="fullname_exp"/>
                <TextField source="fullname_dst" label="Destinataire" sortBy="fullname_dst"/>
                <TextField source="message" label="Message" sortBy="message"/>
                <FunctionField render={record => <ShowButton  basePath={'/aerien/'+record.ord_id+'/show'}  label="Afficher" record={record} /> } />
                <FunctionField render={record =>(record.reste_a_payer) ?  <FormDialogPayement from="list" for='livraison' data={record}/> :  null } />
                <FunctionField render={record => setReste_a_payer(record.reste_a_payer) } />
            </Datagrid>
        </List>
       ) ;
    };

export default ListReception;

const PostBulkActionButtons = props => (
    <Fragment>
         <ResetViewsButton label={has_role(props.roles,'ROLE_MANAGER') ? 'Annuler reception':'Reçu'}
            title={has_role(props.roles,'ROLE_MANAGER') ? 'Annuler la reception des colis séléctionnés':'Reception des colis séléctionnés'}
            content={has_role(props.roles,'ROLE_MANAGER') ?'Voulez vous annuler la reception des colis séléctionnés ?':'Avez vous reçu les colis séléctionnés ?'} {...props} 
            url={process.env.REACT_APP_URL +'/etiq/updateRecepEtiqAerienMaritime?ids=' + props.selectedIds+'&code='+props.filterValues.code}
            startIcon={<HourglassEmptyIcon/>}
        />
    </Fragment>
);

/*
const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        
            <CreateButton basePath={basePath} />
        </TopToolbar>
    );
};

*/




/*
const GuetsiAction = ({
    bulkActions,
    basePath,
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter,
    total,
    data,
    record,
    ...rest
}) => (
    <TopToolbar>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
            record,
            data
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        
        <Button source="credit_status" label="Colis"  color="primary" onClick={()=>this.handleClick()}> <VerticalSplit /> </Button>  
        <CreateButton basePath={basePath} />

    </TopToolbar>
);



*/